import el from './el';
import en from './en';
import fr from './fr';
import it from './it';
import ja from './ja';
import mk from './mk';
import nl from './nl';

const locales = {
  en,
  it,
  ja,
  nl,
  fr,
  el,
  mk
};

export default locales;
